import { createContext, useContext, useState, ReactNode } from 'react';

interface ClanSwitchContextType {
  isLoading: boolean;
  clanName: string;
  showClanLoader: (clanName: string) => void;
  hideClanLoader: () => void;
}

const ClanSwitchContext = createContext<ClanSwitchContextType | undefined>(undefined);

export function useClanSwitch() {
  const context = useContext(ClanSwitchContext);
  if (!context) {
    throw new Error('useClanSwitch must be used within a ClanSwitchProvider');
  }
  return context;
}

interface ClanSwitchProviderProps {
  children: ReactNode;
}

export function ClanSwitchProvider({ children }: ClanSwitchProviderProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [clanName, setClanName] = useState('');

  const showClanLoader = (name: string) => {
    setClanName(name);
    setIsLoading(true);
  };

  const hideClanLoader = () => {
    setIsLoading(false);
    setClanName('');
  };

  return (
    <ClanSwitchContext.Provider
      value={{
        isLoading,
        clanName,
        showClanLoader,
        hideClanLoader,
      }}
    >
      {children}
    </ClanSwitchContext.Provider>
  );
}